import { OnInit, OnDestroy, Component, ViewChild, ElementRef, Input, OnChanges, SimpleChanges, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs";
import { AppDatatableConfigOptions } from "../models";

@Component({
    selector: 'app-datatable-column-selector',
    templateUrl: './column-selector.component.html'
})

export class AppDatatableColumnSelectorComponent<T> implements OnInit, OnChanges, OnDestroy {

    isOpen: boolean = false;

    isDirty: boolean = false;
    
    @ViewChild('columnSelectorDropdown')
    columnSelectorDropdown: ElementRef;

    @Input()
    public columns: Observable<Array<any>>;

    @Input()
    public configEvent: EventEmitter<AppDatatableConfigOptions>;

    @Input()
    public dividerColumns: Array<number>;

    @Input()
    public iconAltColor: boolean = false;

    @Output()
    public onDisplayColumns: EventEmitter<any>;

    allColumns: Array<any>;
    private _columnsSubscription: Subscription;
    private _configEventSubscription: Subscription;

    constructor() {
        this.dividerColumns = new Array<number>();
        this.onDisplayColumns = new EventEmitter<any>();
    }
    
    ngOnInit(): void {
    }

    ngOnChanges(inputChanges: SimpleChanges): void {
        //columns changed
        if (inputChanges.columns && inputChanges.columns.currentValue) {
            if(this._columnsSubscription) {
                this._columnsSubscription.unsubscribe();
            }
            this._columnsSubscription = this.columns.subscribe((columns) => {
                if(columns.length>0) {
                    this.allColumns = [];
                    this._setAllColumns(columns);
                }
            });
        }

        if (inputChanges.configEvent && inputChanges.configEvent.currentValue) {
            this._configEventSubscription = this.configEvent.subscribe(config => {
                // set id in model
                console.log(">>> _configEventSubscription", config);
                if(config && config.columns.length>0) {
                    this.allColumns = [];
                    this._setAllColumns(config.columns);
                }
            });
        }
    }

    ngOnDestroy(): void {
        if(this._columnsSubscription) {
            this._columnsSubscription.unsubscribe();
        }
        if(this._configEventSubscription) {
            this._configEventSubscription.unsubscribe();
        }
    }

    showDivider(index: number): boolean {
        return (this.dividerColumns.indexOf(index)>-1);
    }

    onOpenChange(event): void {
        this.isOpen = event;
    }

    onHidden(event): void {
        if(this.isDirty) {
            let displayColumns = this.allColumns.filter(function (c) {
                // always send columns that can't be hidden
                return (c.show);
            });
            console.log(">>displayColumns: ", displayColumns);
            this.onDisplayColumns.emit(displayColumns);
            this.isDirty = false;
        }
    }

    onSelectionChange(event): void {
        this.isDirty = true;
    }

    onDropdownOutsideClick(clicked: boolean) {
        if(clicked) {
            this.isOpen = false;
        }
    }

    private _setAllColumns(columns : Array<any>): void {
        columns.forEach((col) => {
            if(col.hideOnInit) {
                col.show = false;
            } else {
                col.show = true;
            }
            if(col.lockDisplay) {
                col.disableSelection = true;
            }
            this.allColumns.push(col);
        });

        console.log(">> _setAllColumns", this.allColumns);
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/column-selector/column-selector.component.ts